import { useRecoilValue } from "recoil";
import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { PlatformPeople } from "../../../Component/Model/Dto/Platform/PlatformPeople";
import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";
import { userRolesState } from "../../../State/user.Atom";
import { PlatformPeopleEditRole, UserAdminRole } from "../../../Component/Common/Constants/UserRoles";

interface PlatformPeopleRows {
    platformPeopleId: string,
    fullName: string,
    idNumber: string,
    employeeCode: string,
    jobTitle: string,
    race: string,
    gender: string,
    actions?: ActionType[];
}

interface PlatformPeopleTable {
    columns: Array<TableColumn>;
    rows: Array<PlatformPeopleRows>;
}

export function PlatformPeopleTableMapper(dataObject: PlatformPeople[], handleEdit: (personId: string) => void, deletePlatformPerson: (personId: string, fullName: string) => void): PlatformPeopleTable {
    const editRoleAccess = [
        PlatformPeopleEditRole,
        UserAdminRole
    ]

    const userRoles = useRecoilValue(userRolesState);
    const isEditable = userRoles.some(r => editRoleAccess.includes(r));
    function getActionsColumn(item: PlatformPeople, index: number) {
        const actions: ActionType[] = [
            isEditable ? {
                key: `assign_${index}`,
                label: 'Edit Record',
                action: () => {
                    handleEdit(item.platformPeopleId!);
                },
                icon: {
                    color: 'info',
                    name: 'edit'
                }
            } :
                {
                    key: `assign_${index}`,
                    label: 'view Record',
                    action: () => {
                        handleEdit(item.platformPeopleId!);
                    },
                    icon: {
                        color: 'info',
                        name: 'visibility'
                    }
                },
            isEditable
                ? {
                    key: index.toString(),
                    label: 'Delete',
                    action: () => {
                        deletePlatformPerson(item.platformPeopleId!, item.fullName!);
                    },
                    icon: {
                        color: 'error',
                        name: 'delete',
                    },
                }
                : null,
        ].filter(Boolean)  as ActionType[];

        return actions;
    }

    const columns = [
        { Header: 'Full Name', accessor: 'fullName', id: 'fullName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'ID Number', accessor: 'idNumber', id: 'idNumber', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Employee Code', accessor: 'employeeCode', id: 'employeeCode', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Job Title', accessor: 'jobTitle', id: 'jobTitle', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Race', accessor: 'race', id: 'race', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Gender', accessor: 'gender', id: 'gender', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];
    if (dataObject !== undefined && dataObject.length > 0) {
        const rows = dataObject.map((item: PlatformPeople, index: number) => ({
            platformPeopleId: item.platformPeopleId!,
            fullName: item.fullName!,
            idNumber: item.idNumber,
            employeeCode: item.employeeCode,
            jobTitle: item.jobTitle!,
            race: item.race!,
            gender: item.gender!,
            actions: getActionsColumn(item, index),
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}
